
import ViewHeader from "@/components/ViewHeader.vue";
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "@/store";
import { api } from "@/services/Api";

export default defineComponent({
  components: { ViewHeader },
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const messages = computed(() => store.state.messages);
    async function removeMessage(id: number) {
      store.commit("removeMessage", id);
      await api.MarkReadCashierMessage(id);
    }
    return { t, messages, removeMessage };
  },
});
